import { useState } from "react";
import Invoice from "../Invoice/Invoice";
import Design from "../Invoice/Design";
import { Card, Radio } from "antd";

function ShopProfile(props) {
  const [activeKey, setActiveKey] = useState("invoiceField");

  const options = [
    {
      label: "Invoice Field",
      value: "invoiceField",
    },
    {
      label: "Design",
      value: "design",
    },
  ];
  const handleChange = (e) => {
    const value = e.target.value;
    setActiveKey(value);
  };
  return (
    <>
      <Card
        style={{
          margin: "20px 0",
          boxShadow: "none",
        }}
      >
        <Radio.Group
          options={options}
          onChange={handleChange}
          value={activeKey}
          optionType="button"
        />
      </Card>
      {activeKey === "invoiceField" && <Invoice />}
      {activeKey === "design" && <Design />}
    </>
  );
}

export default ShopProfile;
